import React, { Component } from 'react'
import 'react-select/dist/react-select.css'
import VendorPaymentApp from './container'

import logo from './images/logo.png'
import './css/reset.css'


import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/css/bootstrap-theme.min.css'

import './App.css'
import ajax from './utils/Ajax';

class App extends Component {
  state={dataDate: ''};
  componentWillMount() {
    ajax.get(`/vendorPayments`,{params:{$top:1,$select:'data_date'}})
      .then((res) => {
        if(res && res.data && res.data.value[0] && res.data.value[0].DATA_DATE){
          this.setState({dataDate: `Data updated on ${(new Date(res.data.value[0].DATA_DATE)).toLocaleDateString()}`})
        } else {
          this.setState({dataDate: ''})
        }
      })
  }
  render() {
    return (
      <div className="App">
        <div className="App-header">
          <a href="https://www.sandiegounified.org">
            <img src={logo} alt="SDUSD" />
          </a>
          <h2>Vendor Payment Lookup</h2>
        </div>
        <div className="container">
          <VendorPaymentApp />
        </div>
        <footer>
          <h5>{this.state.dataDate}</h5>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js